import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'

import { getPkgTaxes } from '../paymentsService'
import { TaxesData } from '../types/TaxesData'

export const useGetPackageTaxes = (packageId: string | undefined, enabled: boolean = true) => {
  return useQuery<TaxesData>({
    queryKey: [QUERY_KEYS.PACKAGE_TAXES, packageId],
    queryFn: () => getPkgTaxes(packageId!),
    enabled: enabled && !!packageId,
  })
}
